import React from 'react';
import {
  Box,
  Button,
  ButtonGroup,
  MenuItem,
  Typography,
} from '@material-ui/core';
import { Form } from '../../../form';
import { FormSectionInfo } from '../../../form/components';
import { SelectLabelled } from '../../../../packages/select-labelled';
import { RHFRadioGroup } from '../../../../packages/react-hook-form/radio-group/radio-group';
import { RadioLabelled } from '../../../../packages/radio-labelled';
import { FormSectionContainer } from '../../../form/components/form-section-container/form-section-container';
import { BuyProcessFormNextButton } from '../buy-process-form-next-button/buy-process-form-next-button';
import { BuyProcessFormAdminSubmitButton } from '../buy-process-form-admin-submit-button/buy-process-form-admin-submit-button';
import { useFiscalYear } from './use-fiscal-year';
import { FiscalYearLabel, fiscalYearOptions } from './fiscal-year-utils';

export const BuyProcessFormFiscalYear = () => {
  const {
    errors,
    reset,
    onSubmit,
    control,
    closingDateOptions,
    fiscalYear,
    setFiscalYear,
    onBack,
    onForward,
    isUpdating,
  } = useFiscalYear();

  const getClosingDateLabel = (date: string, index: number) => {
    if (index === 0) return date;
    return `${date} (förlängt första räkenskapsår)`;
  };

  return (
    <Form onSubmit={onSubmit}>
      <div>
        <FormSectionInfo.InfoBoxTitled title="Räkenskapsår">
          <Typography>
            Våra standardlagerbolag har fyra olika räkenskapsår där kalenderår
            (1/1 - 31/12) är det vanligaste, men vi har också brutna
            räkenskapsår som du kan se i listan nedan. <br /> <br />I vissa fall
            kan första räkenskapsåret vara förlängt (dock max 18 månader) så där
            möjligheten finns ger vi dig två val nedan för bokslutsdatum. Välj
            det som passar dig bäst.
          </Typography>
        </FormSectionInfo.InfoBoxTitled>

        <FormSectionContainer>
          <SelectLabelled
            required
            label="Räkenskapsår"
            value={fiscalYear}
            name="fiscalYearSelect"
            SelectProps={{
              onChange: (event) => {
                setFiscalYear(event.target.value as any);
                reset({ firstClosingDate: '' });
              },
            }}
          >
            {fiscalYearOptions.map((value) => {
              const label = FiscalYearLabel[value];

              return (
                <MenuItem key={value + label} value={value}>
                  {label}
                </MenuItem>
              );
            })}
          </SelectLabelled>

          <Box mt={4}>
            <RHFRadioGroup
              label="Första bokslutsdatum *"
              control={control}
              name="firstClosingDate"
              errors={errors}
            >
              {Object.values(closingDateOptions).map(
                (closingDateOption, index) => (
                  <RadioLabelled
                    key={index}
                    value={closingDateOption}
                    label={getClosingDateLabel(closingDateOption, index)}
                  />
                ),
              )}
            </RHFRadioGroup>
          </Box>
        </FormSectionContainer>
      </div>

      <ButtonGroup>
        <Button onClick={onBack}>Tillbaka</Button>
        <BuyProcessFormNextButton onClick={onForward}>
          Nästa
        </BuyProcessFormNextButton>
        <BuyProcessFormAdminSubmitButton loading={isUpdating}>
          Spara
        </BuyProcessFormAdminSubmitButton>
      </ButtonGroup>
    </Form>
  );
};
